import { __extends } from "tslib";
import React from "react";
import { Helmet } from "react-helmet";
var Meta = /** @class */function (_super) {
  __extends(Meta, _super);
  function Meta() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Meta.prototype.render = function () {
    var title = this.props.title;
    return /*#__PURE__*/React.createElement("div", {
      className: "application"
    }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, title)));
  };
  return Meta;
}(React.Component);
export default Meta;
;